import 'css-chunksrc/client/common/resourceAllocationMenu/resourceTags/tag/styles.scss';export default {
  "tag": "_tag_6vs8n_1",
  "name": "_name_6vs8n_11"
};